import React, { Component } from 'react';
import { CircularProgress, Box } from '@material-ui/core';

/**
 * HOC wrapper around component which will either render a loaded component
 * or a progress indicator in its place.
 */
export default function withLoading(LoadedComponent) {
    return class withLoading extends Component {
        constructor(props) {
            super(props);

            this.state = {
                loading: true,
            };
        }

        setLoading = (newValue) => {
            this.setState({
                loading: newValue,
            });
        };

        renderLoading() {
            return (
                <Box
                    height={'70vh'}
                    width={'100%'}
                    display={'flex'}
                    justifyContent={'center'}
                    alignItems={'center'}
                >
                    <CircularProgress />
                </Box>
            );
        }

        render() {
            const { loading } = this.state;

            return (
                <LoadedComponent
                    {...this.props}
                    isLoading={loading}
                    setLoading={this.setLoading}
                    renderLoading={this.renderLoading}
                />
            );
        }
    };
}
